import axios from 'axios';
import { API_URL } from '../../config/system/systemConfig';
import { SearchesModel } from '../../models/platform/searchesModel';
import { ResponseSuccessModel } from '../../models/system/responseSuccessModel';
import authHeader from '../../utils/authHeaderUtils';
import { handleAxiosError } from '../../utils/errorUtils';

class ClinicalTrialsApi {

  async getOutcomeDetails(search_execution_id: string, nct_id: string) {
    try {
      const response = await axios.get(
        `${API_URL}/api/data-sections/clinical-trials/studies/${nct_id}/outcomes`,
        {
          params: { search_execution_id },
          headers: authHeader(),
        }
      );

      return response.data as ResponseSuccessModel;
    } catch (error) {
      return handleAxiosError(error);
    }
  }

  async getSponsorDetails(search_execution_id: string, nct_id: string) {
    try {
      const response = await axios.get(
        `${API_URL}/api/data-sections/clinical-trials/studies/${nct_id}/sponsors`,
        {
          params: { search_execution_id },
          headers: authHeader(),
        }
      );

      return response.data as ResponseSuccessModel;
    } catch (error) {
      return handleAxiosError(error);
    }
  }

  async getStudies(search_execution_id: string, search: SearchesModel) {
    try {
      const response = await axios.post(`${API_URL}/api/data-sections/clinical-trials/studies`, { search_execution_id, search },
        {
          headers: authHeader(),
        });

      return response.data as ResponseSuccessModel;
    } catch (error) {
      return handleAxiosError(error);
    }
  }

  async getStudyById(search_execution_id: string, nct_id: string, __ci_system_search_date_key: Date) {
    try {
      const payload =
      {
        search_execution_id,
        nct_id,
        __ci_system_search_date_key,
      };

      const config =
      {
        headers: authHeader(),
      };

      const response = await axios.post(`${API_URL}/api/data-sections/clinical-trials/studies/detail`, payload, config);

      return response.data as ResponseSuccessModel;
    } catch (error) {
      return handleAxiosError(error);
    }
  }

}

const clinicalTrialsApi = new ClinicalTrialsApi();
export default clinicalTrialsApi;
